module.exports = __webpack_public_path__ + "img/6.26b3e5c4.jpg";